import React, { useState, useContext } from "react";
import { StateContext } from "../../../state/index";
import Plastic from "../../library/Plastic/index";
import ConfigComponent from "../../ConfigComponent";
import Title from '../../library/Title';
import { TOKEN_TYPES } from "../../../utils/enums";

const dot = String.fromCharCode("8226");
const ccDots = dot + dot + dot + dot;

const formatCcNumber = lastFour => {
  return `${ccDots} ${ccDots} ${ccDots} ${lastFour}`;
};

export const FinixAcceptView = ({children}) => {
  const [{ configuration, tokens }] = useContext(StateContext);
  const [isFlipped, setIsFlipped] = useState(false);

  const flipCard = () => setIsFlipped(!isFlipped);

  const { name, brand, last_four, expiration_month, expiration_year } = tokens[TOKEN_TYPES.RECIPIENT_LOGIN].additional_data.network_response.payment_instrument;

  return (
    <>
      <Title>
        <h1>Accept Payment</h1>
      </Title>
      <section className="main">
        <p className="description"><ConfigComponent config={configuration.acceptPayment.description} /></p>
        <div style={{padding: '1em'}}>
          <Plastic
            onClick={flipCard}
            number={formatCcNumber(last_four)}
            name={name.toLowerCase()}
            expiration={`${expiration_month}/${expiration_year}`}
            cvc={null}
            brand={brand.toLowerCase()}
            focused={isFlipped ? "cvc" : "name"}
          />
        </div>
        {children}
      </section>
    </>
  );
};

export default FinixAcceptView;


